export const SLACK_400F_WORKSPACE_HOSTNAME = '400f-jp.slack.com'
